import { auth } from '@/helpers/core'
import { AxiosResponse } from "axios"

export interface User {
	role: string
	login?: string
}

export default {
	get (): Promise<AxiosResponse<User>> {
		return auth.get('/')
	},
	logIn ({ login, password }: { login: string, password: string }): Promise<AxiosResponse<void>> {
		return auth.post('/', { login, password })
	},
	logOut (): Promise<AxiosResponse<void>> {
		return auth.post('/logout', { })
	}
}
